export default "__VITE_ASSET__ElVGGFXu__"